<div [formGroup]="parentFormGroup">
    <label class="date-picker-label">{{ data.label }}</label>
    <input type="date" class="date-picker"
        [formControlName]="data.name"
        [ngClass]="{'date-picker--can-type': data.acceptInput}"/>
</div>